import noop from 'lodash/noop';
import { createContext } from 'react';

import type { FeedbackButtonsProps } from './types';
import type { useDialog } from 'shared/components/Dialog';

// TODO: think about general solution for dialog context probably with extra generic properties
export type Context = ReturnType<typeof useDialog> & FeedbackButtonsProps;

export const context = createContext<Context>({
  onClose: noop,
  onOpen: noop,
  open: false,
  messageId: '',
});

export const { Provider } = context;
